/**
 * 3.1.1.5 2계층 방어 Store
 *
 * @since 2017-12-12
 * @author devp020
 */

import {i18n} from '~/plugins/i18n'

const initTwoLayerData = () => {
  return {
    device_id_list: [],
    device_list_name: '',
    layer2_cm_arp_action_type: 1,
    layer2_cm_arp_sync_yn: 1,
    layer2_cm_arp_use_yn: 1,
    layer2_cm_desc: '',
    layer2_cm_id: 0,
    layer2_cm_static_mac_action_type: 1,
    layer2_cm_static_mac_sync_yn: 1,
    layer2_cm_static_mac_use_yn: 1,
    layer2_cm_sync_yn: 1,
    layer2_cm_uname: ''
  }
}

const initMacData = () => {
  return {
    layer2_cm_mac_addr_val: '',
    layer2_cm_mac_id: 1,
    layer2_cm_mac_ip: '',
    layer2_cm_mac_ip_ver_type: 1
  }
}
export const state = () => ({
  // api url 목록
  apiUrl: {
    twoLayerDefenseUrl: '/api/cm/layer2/cm'
  },

  twoLayerDefenseList: [],
  twoLayerDefenseMacList: [],
  selectedData: initTwoLayerData(),
  selectedMacData: initMacData(),
  twoLayerDefenseResult: null,
  postTwoLayerDefenseResult: null,
  twoLayerDefenseMacResult: null,
  putTwoLayerDefenseMacResult: null,
  // delTwoLayerDefensMacResult: null,
  selectRowItem: {},
  errorMessage: null
})

export const mutations = {
  // Row DoubleClick
  setSelectRowItem (state, data) {
    state.selectRowItem = data
  },
  // 2계층 방어 편집 데이터 조회
  mutTwoLayerDefenseSetData (state, data) {
    const selectedRowData = data[0]
    const deviceInfo = selectedRowData.layer2_cm_device
    if (deviceInfo.length > 0) {
      const deviceName = deviceInfo[0].device_uname
      const deviceLen = deviceInfo.length
      let result = void 0
      if (deviceLen > 1) {
        result = i18n.t('cmn.deviceTypeText', {name: deviceName, cnt: deviceLen - 1})
      } else if (deviceLen === 1) {
        result = `${deviceName}`
      } else {
        result = ''
      }
      selectedRowData.device_id_list = []
      for (const key of deviceInfo) {
        selectedRowData.device_id_list.push(key.device_id)
      }
      selectedRowData.device_list_name = result
    }
    if (!selectedRowData.device_id_list) {
      selectedRowData.device_id_list = []
    }
    if (!selectedRowData.device_list_name) {
      selectedRowData.device_list_name = ''
    }
    state.selectedData = selectedRowData
  },
  // 2계층 방어 편집 데이터 초기화
  twoLayerDefenseResetData (state) {
    state.selectedData = initTwoLayerData()
    state.twoLayerDefenseMacList = []
  },
  // 2계층 방어 통합 설정 조회
  mutTwoLayerDefense (state, payload) {
    state.twoLayerDefenseList = payload.filter(item => {
      item.device_id_list = '<div>' + item.layer2_cm_device.map(item => {
        return item.device_uname
      }).join('</div><div>') + '</div>'
      return item
    })
  },
  changeAllSyncYn (state, data) {
    const syncData = _.cloneDeep(state.twoLayerDefenseList)
    _.forEach(syncData, o => {
      o.layer2_cm_sync_yn = data
    })
    state.twoLayerDefenseList = syncData
  },
  // 2계층 방어 통합 설정 추가 (빈설정)
  mutAddEmptySettings: (state, item) => {
    state.twoLayerDefenseList.push(item)
  },
  // 2계층 방어 통합 설정 추가 완료 처리, 수정처리
  mutPutTwoLayerDefense (state, payload) {
    state.twoLayerDefenseResult = payload
  },
  // 2계층 방어 통합 설정 삭제
  mutDelTwoLayerDefense (state, payload) {
    state.twoLayerDefenseResult = payload
  },
  // 2계층 방어 통합 설정 2계층 방어 통합 설정 동기화 여부 수정
  mutPostTwoLayerDefense (state, payload) {
    state.postTwoLayerDefenseResult = payload
  },
  // 2계층 방어 통합 설정 MAC 조회
  mutTwoLayerDefenseMac (state, payload) {
    state.twoLayerDefenseMacList = payload
  },
  mutTwoLayerDefenseMacReset (state) {
    state.twoLayerDefenseMacList = []
  },
  // 2계층 방어 통합 설정 MAC 추가
  mutPostTwoLayerDefenseMac (state, payload) {
    state.twoLayerDefenseMacResult = payload
  },
  // 2계층 방어 통합 설정 MAC 수정
  mutPutTwoLayerDefenseMac (state, payload) {
    state.putTwoLayerDefenseMacResult = payload
  },
  // 2계층 방어 통합 설정 MAC 삭제
  mutDelTwoLayerDefenseMac (state, payload) {
    state.twoLayerDefenseMacResult = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  async applyAction () {
    const result = await this.$axios.$put(`/api/cm/layer2/cm/apply`, null, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async cancelAction () {
    const result = await this.$axios.$put(`/api/cm/layer2/cm/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  // 2계층 방어 통합 설정 조회
  async acsTwoLayerDefense ({commit, state}) {
    let bRet = false
    try {
      const res = await this.$axios.$get(`${state.apiUrl.twoLayerDefenseUrl}/0`)
      if (res.code === 'ok') {
        commit('mutTwoLayerDefense', res.result)
        bRet = true
      } else {
        commit('mutTwoLayerDefense', [])
        commit('mutationErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
    return bRet
  },
  // 2계층 방어 통합 설정 편집 데이터 조회
  async acsTwoLayerDefenseGetData ({commit, state}, defenseId) {
    let bRet = false
    try {
      const res = await this.$axios.$get(`${state.apiUrl.twoLayerDefenseUrl}/${defenseId}`)
      if (res.code === 'ok') {
        commit('mutTwoLayerDefenseSetData', res.result)
        bRet = true
      } else {
        commit('mutTwoLayerDefenseSetData', {})
        commit('mutationErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
    return bRet
  },
  // 2계층 방어 통합 설정 추가 (빈설정)
  async acsAddEmptySettings ({commit, state}) {
    const param = _.omit(state.selectedData, ['layer2_cm_id'])
    const result = { error: null }
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${state.apiUrl.twoLayerDefenseUrl}`, param, {loading: false, successAlert: false})
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 2계층 방어 통합 설정 추가 완료 처리, 수정처리
  async acsPutTwoLayerDefense ({commit, state}) {
    const result = { error: null }
    const params = state.selectedData
    if (params.device_id_list === undefined) {
      params.device_id_list = []
    }
    try {
      const res = await this.$axios.$put(`${state.apiUrl.twoLayerDefenseUrl}`, params, {successAlert: false})
      commit('mutPutTwoLayerDefense', res)
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 2계층 방어 통합 설정 삭제
  async acsDelTwoLayerDefense ({commit, state}, payload) {
    const result = { error: null }
    const etcParam = payload.etcParam
    try {
      let res = null
      if (etcParam !== undefined) {
        res = await this.$axios.$put(`${state.apiUrl.twoLayerDefenseUrl}/multi`, payload.idList, etcParam, {successAlert: false})
      } else {
        res = await this.$axios.$put(`${state.apiUrl.twoLayerDefenseUrl}/multi`, payload.idList, {successAlert: false})
      }
      commit('mutDelTwoLayerDefense', res)
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 2계층 방어 통합 설정 2계층 방어 통합 설정 동기화 여부 수정
  async acsPostTwoLayerDefense ({commit, state}, payload) {
    const result = { error: null }
    try {
      const res = await this.$axios.$post(`${state.apiUrl.twoLayerDefenseUrl}/multi`, payload)
      commit('mutPostTwoLayerDefense', res)
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 2계층 방어 통합 설정 MAC 조회
  async acsTwoLayerDefenseMac ({commit, state}, defenseId) {
    let bRet = false
    try {
      const res = await this.$axios.$get(`${state.apiUrl.twoLayerDefenseUrl}/mac/${defenseId}`, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutTwoLayerDefenseMac', res.result)
        bRet = true
      } else {
        commit('mutTwoLayerDefenseMac', [])
        commit('mutationErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
    return bRet
  },
  // 2계층 방어 통합 설정 MAC 추가
  async acsPostTwoLayerDefenseMac ({commit, state}, param) {
    const result = { error: null }
    const params = param
    try {
      const res = await this.$axios.$post(`${state.apiUrl.twoLayerDefenseUrl}/mac`, params, {loading: false, successAlert: false})
      // commit('mutPostTwoLayerDefenseMac', res)
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 2계층 방어 통합 설정 MAC 수정
  async acsPutTwoLayerDefenseMac ({commit, state}, param) {
    const result = { error: null }
    const params = param
    try {
      const res = await this.$axios.$put(`${state.apiUrl.twoLayerDefenseUrl}/mac`, params, {successAlert: false})
      // commit('mutPutTwoLayerDefenseMac', res)
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 2계층 방어 통합 설정 MAC 삭제
  async acsDelTwoLayerDefenseMac ({commit, state}, payload) {
    const result = { error: null }
    try {
      const res = await this.$axios.$put(`${state.apiUrl.twoLayerDefenseUrl}/mac/multi`, payload, {successAlert: false})
      commit('mutDelTwoLayerDefenseMac', res)
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  async onEventRuleChkInputAxios ({commit, state}, param) {
    try {
      const data = await this.$axios.$post(`${state.apiUrl.twoLayerDefenseUrl}/multi`, param, {loading: false, successAlert: false})

      if (data.code !== 'ok') {
        return false
      }
      return data
    } catch (error) {
      return error
    }
  }
}

export const strict = false
